import type { SasTokenResponse } from 'stores/SasTokenStore';
import type { VideoLite } from 'stores/PlayerPerformanceStore';

// Blob layout — mirrors the BFF's TrackMan.Football.Services.SDK BlobUrlHelper:
//   sessions/{sessionId}/measurements/{measurementId}/videos/{videoId}.mp4
//   sessions/{sessionId}/measurements/{measurementId}/thumbnails/{videoId}.jpg
const videoPath = (sessionId: string, measurementId: string, videoId: string): string =>
  `sessions/${sessionId}/measurements/${measurementId}/videos/${videoId}.mp4`;
const thumbnailPath = (sessionId: string, measurementId: string, videoId: string): string =>
  `sessions/${sessionId}/measurements/${measurementId}/thumbnails/${videoId}.jpg`;

/**
 * Builds direct blob video URLs for a kick from its `videoIds` and a preloaded SAS token — so opening
 * a kick's videos needs no per-kick session fetch. Mirrors the server-side builder in
 * `MeasurementService.BuildVideoSource` (account = SAS `entityPath`, container = SAS `endpoint`, and the
 * token already includes the leading '?'). Returns [] when the token or ids are missing.
 */
export function buildKickVideos(
  sas: SasTokenResponse | null,
  sessionId: string,
  measurementId: string,
  videoIds: string[] | undefined | null,
): VideoLite[] {
  if (!sas?.token || !sas.entityPath || !sas.endpoint || !videoIds?.length) return [];
  const base = `https://${sas.entityPath}.blob.core.windows.net/${sas.endpoint}`;
  return videoIds.map((videoId) => ({
    videoId,
    url: `${base}/${videoPath(sessionId, measurementId, videoId)}${sas.token}`,
    thumbnailUrl: `${base}/${thumbnailPath(sessionId, measurementId, videoId)}${sas.token}`,
  }));
}
